import { render, staticRenderFns } from "./EmailFileManagement.vue?vue&type=template&id=6556ce3a&scoped=true&"
import script from "./EmailFileManagement.vue?vue&type=script&lang=js&"
export * from "./EmailFileManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6556ce3a",
  null
  
)

export default component.exports